export default "__VITE_ASSET__IAc1etcs__"